var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.077,
    height: 14.23,
    viewBox: "0 0 17.077 14.23",
    transform: "rotate(180 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.269,11.961a.533.533,0,0,1-.386-.165L6.148,7.883a.534.534,0,0,1,.386-.9H8.49V2.889A.891.891,0,0,1,9.38,2h1.779a.891.891,0,0,1,.889.889V6.981H14a.534.534,0,0,1,.386.9L10.655,11.8A.533.533,0,0,1,10.269,11.961Z",
    transform: "translate(-1.731)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.831,20.846H1.245A1.247,1.247,0,0,1,0,19.6v-.356A1.247,1.247,0,0,1,1.245,18H15.831a1.247,1.247,0,0,1,1.245,1.245V19.6A1.247,1.247,0,0,1,15.831,20.846Z",
    transform: "translate(0 -4.616)",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.af1473367f2cfe4f46ca1a7b89da1309.svg";
export { ForwardRef as ReactComponent };